import { useState } from "react";
import { FloatingComponent } from "../../components/layout-components/FloatingComponent";
import { DisplayConclaveEventList } from "./DisplayConclaveEventList";

function PreConclave() {
  const sdgData = [
    "Good Health and Well-Being",
    "Quality Education",
    "Clean Water and Sanitation",
    "Affordable and Clean Energy",
    "Industry, Innovation and Infrastructure",
    "Sustainable Cities and Communities",
    "Climate Action",
    "Life Below Water",
  ];
  const [showConclave, setShowConclave] = useState(false);
  const [selectedSDG, setSelectedSDG] = useState(null);
  const handlePopUp = (mode = "CLOSE") => {
    mode === "CLOSE" ? setShowConclave(false) : setShowConclave(true);
  };

  const getSdgName = (index) => {
    const sdgName = sdgData.at(index);

    return sdgName;
  };

  const handleOpen = (SDGIndex) => {
    handlePopUp("OPEN");
    const sdgName = sdgData.at(SDGIndex);
    console.log(sdgName, SDGIndex);
    setSelectedSDG(sdgName);
  };

  let sdgCards = sdgData.map((element, index) => (
    <Cards handleOpen={() => handleOpen(index)} num={index} content={element} />
  ));

  return (
    <>
      <div className="pre-conclave py-10">
        <h1 className="heading">Pre Conclave Events</h1>
        <div className="pre-conclave-cards">{sdgCards}</div>
      </div>
      {showConclave && (
        <FloatingComponent className=" bg-slate-400 bg-opacity-60 ">
          <DisplayConclaveEventList
            selectedSDG={selectedSDG}
            handleClose={() => handlePopUp("CLOSE")}
          />
        </FloatingComponent>
      )}
    </>
  );
}

function Cards(props) {
  const [buttonHover, setButtonHover] = useState(false);

  let [style, setStyle] = useState({
    backgroundImage: `url(${require(`../../assets/LandingImages/sdgbg${props.num}.png`)})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  });

  const sdgData = [
    {
      hex: "#4CA146",
      content:
        "Ensure healthy lives and promote well-being for all at all age groups.",
      no: 3,
      numEvents: 47,
    },
    {
      hex: "#C7212F",
      content:
        "Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all.",
      no: 4,
      numEvents: 63,
    },
    {
      hex: "#27BFE6",
      content:
        "Ensure availability and sustainable management of water and sanitation for all.",
      no: 6,
      numEvents: 78,
    },
    {
      hex: "#FBC412",
      content:
        "Ensure access to affordable, reliable, sustainable and modern energy for all.",
      no: 7,
      numEvents: 91,
    },
    {
      hex: "#F26A2E",
      content:
        "Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation.",
      no: 9,
      numEvents: 85,
    },
    {
      hex: "#F89D2A",
      content:
        "Make cities and human settlements inclusive, safe, resilient and sustainable.",
      no: 11,
      numEvents: 54,
    },
    {
      hex: "#407F46",
      content: "Take urgent action to combat climate change and its impacts.",
      no: 13,
      numEvents: 69,
    },
    {
      hex: "#1F97D4",
      content:
        "Conserve and sustainably use the oceans, seas and marine resources for sustainable development.",
      no: 14,
      numEvents: 17,
    },
  ];

  const handleEnter = () => {
    setStyle({
      backgroundImage: "none",
      backgroundColor: sdgData[props.num].hex,
    });
  };

  const handleLeave = () => {
    setStyle({
      backgroundImage: `url(${require(`../../assets/LandingImages/sdgbg${props.num}.png`)})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    });
  };

  const buttonEnter = () => {
    setButtonHover(true);
  };

  const buttonLeave = () => {
    setButtonHover(false);
  };

  return (
    <div
      onClick={() => {
        props.handleOpen();
        style.backgroundImage !== "none" ? handleEnter() : handleLeave();
      }}
      onMouseLeave={handleLeave}
      onMouseEnter={handleEnter}
      style={style}
    >
      {style.backgroundImage !== "none" && (
        <img
          className="sdg-img"
          alt={`sdg${props.num}`}
          src={require(`../../assets/LandingImages/sdg${props.num}.jpg`)}
        ></img>
      )}
      {style.backgroundImage === "none" && (
        <div className="sdg-hover">
          <caption className="goal-no">Goal {sdgData[props.num].no}</caption>
          <p className="sdg-text">{sdgData[props.num].content}</p>
          <span className="hori-line"></span>
          <h2 className="sdg-event-no">{sdgData[props.num].numEvents}</h2>
          <p className="sdg-event-text">events</p>
          <button
            onClick={(e) => {
              e.stopPropagation();
              props.handleOpen();
            }}
            onMouseEnter={buttonEnter}
            onMouseLeave={buttonLeave}
            style={{ color: buttonHover ? sdgData[props.num].hex : "white" }}
            className={`pre-conclave-button hover:bg-white hover:text-[${
              sdgData[props.num].hex
            }]`}
          >
            Preconclave Events
          </button>
        </div>
      )}
    </div>
  );
}

export default PreConclave;
